const isHexColor = (str) => /^#(?:[0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(str);
const combineHexWithOpacity = (hexColor, opacityPercentage) => {
  if (!hexColor) {
    return;
  }
  const alpha = Math.round(opacityPercentage / 100 * 255);
  const alphaHex = alpha.toString(16).padStart(2, "0").toUpperCase();
  return `${hexColor?.slice(0, 7)}${alphaHex}`;
};
const getOpacityFromHex = (hexColorWithAlpha) => {
  if (!hexColorWithAlpha || hexColorWithAlpha.length === 7 || !isHexColor(hexColorWithAlpha)) {
    return 100;
  }
  const hex = hexColorWithAlpha.replace("#", "");
  const alphaHex = hex.slice(6, 8);
  const alphaDecimal = parseInt(alphaHex, 16);
  return Math.round(alphaDecimal / 255 * 100);
};
const getHexColorFromAlpha = (hexColorWithAlpha) => {
  if (!hexColorWithAlpha || hexColorWithAlpha.length === 7 || !isHexColor(hexColorWithAlpha)) {
    return hexColorWithAlpha;
  }
  return hexColorWithAlpha.slice(0, 7);
};
const getContrastYIQ = (originalHex) => {
  let hex = originalHex;
  if (hex.slice(0, 1) === "#") {
    hex = hex.slice(1);
  }
  if (hex.length === 3 || hex.length === 4) {
    hex = hex.split("").map((hex2) => {
      return hex2 + hex2;
    }).join("");
  }
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const alphaHex = hex.substring(6, 8) ?? "FF";
  const a = parseInt(alphaHex, 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1e3;
  return yiq >= 128 || a < 127 ? "black" : "white";
};
export {
  combineHexWithOpacity,
  getContrastYIQ,
  getHexColorFromAlpha,
  getOpacityFromHex,
  isHexColor
};
//# sourceMappingURL=colorUtils.js.map
